'use strict';

require('core/main');

$(document).ready(function () {
    require('./search/searchVariation')();
});
